import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicesPage.css';
import logo from "../assets/bg-remover-logo.png"
function ServicesPage() {
  const navigate = useNavigate();

  const handleLearnMore = (serviceId) => {
    navigate(`/service/${serviceId}`);
  };

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section
        className="services-hero"
        style={{
          background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/assets/sport-marketing-thumb.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">How can we help?</h1>
            <p className="hero-description">
              We offer sports flooring for all major sports like <span className="highlight">Project Consultation</span>, <span className="highlight">Sports Consultancy</span>, <span className="highlight">Physiology</span>, <span className="highlight">Sports & Games Training</span>, <span className="highlight">Admission</span>, <span className="highlight">Scholarship</span>, <span className="highlight">Coaches</span>, <span className="highlight">Physiotherapy</span>, <span className="highlight">Recruitment & Jobs</span>, <span className="highlight">Sports Nutrition</span>, <span className="highlight">Online & Offline Classes</span>, <span className="highlight">Event Managment</span>, <span className="highlight">Domestic & International Sports Tour Program</span> etc.
            </p>
            <div className="motto-section">
              <h2 className="motto-title">
                We are a <span className="accent">one-stop shop</span> for all your <span className="accent">sports infra requirements</span>.
              </h2>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            {/* Turnkey Sports Infrastructure Development */}
            {/* <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Turnkey Sports Infrastructure</h3>
                <p className="service-description">Complete sports facility development from planning to execution</p>
                <button className="service-btn" onClick={() => handleLearnMore('turnkey-sports-infrastructure')}>Learn More</button>
              </div>
            </div> */}

            {/* Project Consultation */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Project Consultation</h3>
                <p className="service-description">Professional advice to help you plan, execute, and grow your sports project with the right strategy and insights.</p>
                <button className="service-btn" onClick={() => handleLearnMore('project-consultation')}>Learn More</button>
              </div>
            </div>

            {/* Sports Flooring Solutions */}
            {/* <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Sports Flooring Solutions</h3>
                <p className="service-description">Professional flooring for all sports and activities</p>
                <button className="service-btn" onClick={() => handleLearnMore('sports-flooring-solutions')}>Learn More</button>
              </div>
            </div> */}

            {/* Sports Consultancy */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Sports Consultancy</h3>
                <p className="service-description">Strategic solutions designed to help sports organizations and facilities improve performance, optimize operations, and achieve long-term success.</p>
                <button className="service-btn" onClick={() => handleLearnMore('sports-consultancy')}>Learn More</button>
              </div>
            </div>

            {/* Ground Development */}
            {/* <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Ground Development</h3>
                <p className="service-description">Complete ground development and infrastructure solutions</p>
                <button className="service-btn" onClick={() => handleLearnMore('ground-development')}>Learn More</button>
              </div>
            </div> */}

            {/* Physiology */}
            {/* <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Physiology</h3>
                <p className="service-description">Sports physiology solutions focused on enhancing athlete performance, improving recovery, and optimizing overall physical output.</p>
                <button className="service-btn" onClick={() => handleLearnMore('physiology')}>Learn More</button>
              </div>
            </div> */}

            {/* Sports & Games */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Sports & Games Training</h3>
                <p className="service-description">High-quality sports training programs focused on skill development, technique improvement, and overall athletic growth.</p>
                <button className="service-btn" onClick={() => handleLearnMore('sports-games-training')}>Learn More</button>
              </div>
            </div>

            {/* Admission */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://stjameschurchschool.com/wp-content/uploads/2023/12/Admission.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Admission</h3>
                <p className="service-description">Helping students navigate school and college admissions with clarity, confidence, and the right information.</p>
                <button className="service-btn" onClick={() => handleLearnMore('admission')}>Learn More</button>
              </div>
            </div>

            {/* Scholarship */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Scholarship</h3>
                <p className="service-description">Access dedicated sports scholarships and financial assistance designed to support talented athletes in pursuing their education and sporting goals.</p>
                <button className="service-btn" onClick={() => handleLearnMore('scholarship')}>Learn More</button>
              </div>
            </div>

            {/* Coaches */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Coaches</h3>
                <p className="service-description">A professional platform connecting athletes with certified coaches, offering expert training, skill development, and personalized guidance.</p>
                <button className="service-btn" onClick={() => handleLearnMore('coaches')}>Learn More</button>
              </div>
            </div>

            {/* Physiotherapy */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Physiotherapy</h3>
                <p className="service-description">Explore  sports industry job opportunities with dedicated recruitment support to help talent connect with the right roles.</p>
                <button className="service-btn" onClick={() => handleLearnMore('physiotherapy')}>Learn More</button>
              </div>
            </div>

            {/* Recruitment */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Recruitment & Jobs</h3>
                <p className="service-description">Explore sports industry job opportunities with dedicated recruitment support to help talent connect with the right roles.</p>
                <button className="service-btn" onClick={() => handleLearnMore('recruitment-jobs')}>Learn More</button>
              </div>
            </div>

            {/* Dietician */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Sports Nutrition</h3>
                <p className="service-description">Expert sports nutrition guidance and personalized diet plans designed to boost performance, enhance recovery, and support overall athlete health.</p>
                <button className="service-btn" onClick={() => handleLearnMore('sports-nutrition')}>Learn More</button>
              </div>
            </div>
            {/* Online and offline CLasses */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhoPwrQMzsQ4Y5XusjXxZHHlaYfrCWaqtjDOBkocSvZKlOkT5Rl-DqTDgq0gp-X1PhAv4&usqp=CAU)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Online & Offline Classes</h3>
                <p className="service-description">Our online and offline sports classes provide structured training, expert guidance, and personalized practice.</p>
                <button className="service-btn" onClick={() => handleLearnMore('online-offline')}>Learn More</button>
              </div>
            </div>
            {/* Event Managment */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKwzVMROKZcyttmVXJ709sUdlbEVamhmQ0SA&s)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Event Management</h3>
                <p className="service-description">Our sports event management ensures smooth planning, clear coordination, and seamless execution.</p>
                <button className="service-btn" onClick={() => handleLearnMore('event-management')}>Learn More</button>
              </div>
            </div>
            {/* Domastic and internation sports tour program */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKwzVMROKZcyttmVXJ709sUdlbEVamhmQ0SA&s)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Domastic & International Sports Tour Program</h3>
                <p className="service-description">Our domestic and international sports tour programs offer well-planned travel, organized training sessions.</p>
                <button className="service-btn" onClick={() => handleLearnMore('domastic-international')}>Learn More</button>
              </div>
            </div>
            {/* Sports Tournament Software */}
            <div className="service-card" style={{
              backgroundImage: 'url(https://static.tournamentsoftware.com/Content/images/downloads/tournamentsoftware.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Sports Tournament Software</h3>
                <p className="service-description">Our sports tournament software ensures smooth event management with smart scheduling, team tracking, and real-time updates.</p>
                <a href="https://www.tournamentsoftware.com/" target="_blank">
                  <button className="service-btn">
                    Learn More
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sports Flooring Products Section */}


      {/* Sports Facilities Showcase */}
      {/* <section className="facilities-showcase">
        <div className="container">
          <h2 className="section-title">Our Sports Facilities</h2>
          <div className="facilities-grid">
            <div className="facility-item">
              <div className="facility-image basketball-court"></div>
              <h4 className="facility-name">Basketball Courts</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image tennis-court"></div>
              <h4 className="facility-name">Tennis Courts</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image running-track"></div>
              <h4 className="facility-name">Running Tracks</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image football-field"></div>
              <h4 className="facility-name">Football Fields</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image volleyball-court"></div>
              <h4 className="facility-name">Volleyball Courts</h4>
            </div>
            <div className="facility-item">
              <div className="facility-image badminton-court"></div>
              <h4 className="facility-name">Badminton Courts</h4>
            </div>
          </div>
        </div>
      </section> */}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building.
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <button className="view-more">View More...</button>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/" className="footer-link">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="/contact" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur - 302019</div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">✉️ askmesportsalliance@gmail.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src={logo} alt="Sports Alliance Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ASK ME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ServicesPage;